import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export const Terms = () => {
  return (
    <div className="max-w-3xl mx-auto py-8 px-4">
      <Card>
        <CardHeader>
          <CardTitle className="text-2xl">Conditions d&apos;utilisation</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate">
          <p className="text-slate-600">
            <strong>Dashboard PRQC - Application interne</strong>
          </p>
          <p className="text-slate-600">
            Cette application est un outil de gestion financière interne développé exclusivement pour 
            Peinture Résidentielle QC. L&apos;accès est réservé aux employés et administrateurs autorisés 
            de l&apos;entreprise.
          </p>
          <h3 className="text-lg font-semibold mt-4">Utilisation des données</h3>
          <p className="text-slate-600">
            Les données financières importées depuis QuickBooks sont utilisées uniquement pour 
            générer des rapports et analyses internes. Aucune donnée n&apos;est partagée avec des tiers.
          </p>
          <h3 className="text-lg font-semibold mt-4">Responsabilité</h3>
          <p className="text-slate-600">
            L&apos;utilisateur est responsable de vérifier l&apos;exactitude des données et des calculs 
            avant de prendre des décisions commerciales basées sur les rapports générés.
          </p>
          <p className="text-slate-500 text-sm mt-8">
            Dernière mise à jour: Février 2026
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Terms;
